import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { formatMatch2Duration } from '../match2.util';

export class Match2DailyChallengeTimer extends View {
  private readonly bg: ImageScaleView;
  private readonly text: LangBitmapFontTextView;

  constructor(opts: ViewOpts) {
    super({ width: 332, height: 40, ...opts });

    this.bg = new ImageScaleView({
      superview: this,
      width: this.style.width,
      height: this.style.height,
      image: 'assets/ui/shared/frames/timer.png',
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 20, right: 20 },
        vertical: { top: 10, bottom: 10 },
      },
    });

    this.text = new LangBitmapFontTextView({
      superview: this,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      centerOnOrigin: true,
      align: 'center',
      verticalAlign: 'center',
      size: 24,
      font: 'Body',
      width: this.style.width - 20,
      height: this.style.height,
      wordWrap: true,
    });
    this.text.localeText = () => '00:00:00';
  }

  public update(remainingTime: number) {
    const time = Math.max(remainingTime, 0);
    this.text.localeText = () => {
      return formatMatch2Duration(time);
    };
  }
}
